import { Component, inject } from '@angular/core';
import { BANK_ACCOUNT_FORM_NAME } from 'src/app/services/form/form.factory';
import { BankAccountForm } from 'src/app/services/form/form.controls';
import { FormService } from 'src/app/services/form/form.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PayeeFormFieldComponent } from '../../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-bank-account-form',
  templateUrl: './bank-account-form.component.html',
  styleUrls: ['./bank-account-form.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    PayeeFormFieldComponent,
    TranslateModule,
  ],
})
export class BankAccountFormComponent {
  private formService = inject(FormService);

  get form(): BankAccountForm {
    return this.formService.form.controls[BANK_ACCOUNT_FORM_NAME]!;
  }

  get account_number() {
    return this.form.controls.account_number;
  }
}
